export type Direction = 'ltr' | 'rtl';

/** Languages written right-to-left; adding Hebrew or Farsi later is one line. */
const RTL_LANGUAGES = new Set(['ar', 'he', 'fa', 'ur']);

export function directionForLanguage(language?: string | null): Direction {
  if (!language) return 'ltr';
  const base = language.trim().toLowerCase().split(/[-_]/)[0];
  return RTL_LANGUAGES.has(base) ? 'rtl' : 'ltr';
}
